import React from 'react';
import PropTypes from 'prop-types';
import {
    List,
    Paper,
    Dialog,
    FlatButton,
    Divider,
} from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Loading from '../../../components/common/Loading/Loading';
import style from '../../../styles/styles';
import Media from '../../../components/media/Media/Media';
import withTranslation from '../../../hoc/withTranslation';

export class MediaList extends React.Component {

    static propTypes = {
        medias: PropTypes.arrayOf(PropTypes.object).isRequired,
        handleDeleteMedia: PropTypes.func,
        handleEditMedia: PropTypes.func,
        title: PropTypes.string.isRequired,
        deletingMedia: PropTypes.bool.isRequired,
    };

    state = {
        openRemoveMedia: false,
        mediaToRemove: null,
    };

    componentWillReceiveProps(nextProps) {
        console.log(this.props, nextProps);
        if (this.props.deletingMedia && !nextProps.deletingMedia) {
            this.handleCloseMedia();
        }
    }

    // Handlers

    handleDeleteMedia = (media) => {
        this.setState({
            openRemoveMedia: true,
            mediaToRemove: media,
        });
    };

    handleCloseMedia = () => {
        this.setState({
            openRemoveMedia: false,
            mediaToRemove: null,
        });
    };

    deleteMedia = () => {
        if (this.state.mediaToRemove && this.props.handleDeleteMedia) {
            this.props.handleDeleteMedia(this.state.mediaToRemove);
        }
    };

    // Render

    renderDeleteMediaDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.deletingMedia}
                onClick={this.handleCloseMedia}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.deletingMedia}
                onClick={this.deleteMedia}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                title={this.props.t('medias.remove_media')}
                modal={false}
                open={this.state.openRemoveMedia}
                onRequestClose={this.handleCloseMedia}
            >
                {this.props.deletingMedia && <Loading paper={false} />}
                {!this.props.deletingMedia && this.state.mediaToRemove &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: this.props.t('medias.delete_confirmation', {
                                    name: this.state.mediaToRemove.name,
                                }),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    render() {
        let medias = this.props.medias;
        let content = medias.map((media, index) => {
            return (
                <div key={media.id}>
                    <Media
                        media={media}
                        user={this.props.user}
                        handleRemove={this.handleDeleteMedia}
                        handleEdit={this.props.handleEditMedia}
                    />
                    {index !== (
                        medias.length - 1
                    ) && <Divider inset={true} />}
                </div>
            );
        });

        let itemCount = medias.length;
        let countLabel = this.props.t('generic.item_count', { count: itemCount });
        return (
            <div>
                {this.renderDeleteMediaDialog()}

                <Paper>
                    <List>
                        <Subheader style={style.subHeader}>
                            {this.props.title} ({countLabel})
                        </Subheader>
                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        app: state.apps.currentApplication,
        deletingMedia: state.points.deletingMedia
            || state.trails.deletingMedia
            || state.news.deletingMedia
            || state.pages.deletingMedia,
        user: state.auth.content,
    };
}

export default connect(mapStateToProps, {})(withTranslation(MediaList));



// WEBPACK FOOTER //
// src/components/media/MediaList/MediaList.js